import { Events } from "@/api/dataSource/api/plugins/events";

export default class EventBus {
    deleteEntity = new Events<{id: number | string}>();
}
